(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["casafab-featured"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('cf-featured-selection')){
customElements.define('cf-featured-selection',class extends HTMLElement{
 connectedCallback(){
  this.vp=this.querySelector('.cfb-feat__viewport');
  this.grid=this.querySelector('.cfb-feat__grid');
  this.prev=this.querySelector('.cfb-feat__arrow--prev');
  this.next=this.querySelector('.cfb-feat__arrow--next');
  if(!this.vp||!this.grid)return;
  this.abort=new AbortController();
  const signal=this.abort.signal;
  this.motion=matchMedia('(prefers-reduced-motion:reduce)');
  this.videos=[...this.querySelectorAll('video[data-src]')];
  this.visible=new Set();
  this.sync=()=>{
   this.videos.forEach(v=>{
    const play=this.visible.has(v)&&!document.hidden&&!this.motion.matches&&!navigator.connection?.saveData;
    if(play){
     if(!v.getAttribute('src')){v.src=v.dataset.src;v.load();}
     v.play().catch(()=>{});
    }else{v.pause();}
   });
  };
  this.videos.forEach(v=>v.addEventListener('playing',()=>v.classList.add('is-playing'),{signal}));
  this.io=new IntersectionObserver(entries=>{
   entries.forEach(e=>{if(e.isIntersecting&&e.intersectionRatio>=.35)this.visible.add(e.target);else this.visible.delete(e.target);});
   this.sync();
  },{threshold:[0,.35]});
  this.videos.forEach(v=>this.io.observe(v));
  document.addEventListener('visibilitychange',this.sync,{signal});
  this.motion.addEventListener('change',this.sync,{signal});
  this.update=()=>{
   this.prev.disabled=this.vp.scrollLeft<=1;
   this.next.disabled=this.vp.scrollLeft+this.vp.clientWidth>=this.vp.scrollWidth-2;
  };
  this.slide=dir=>{
   const card=this.grid.querySelector('.cfb-feat__card');
   if(!card)return;
   const w=card.getBoundingClientRect().width+(parseFloat(getComputedStyle(this.grid).gap)||0);
   this.vp.scrollBy({left:dir*w*Math.max(1,Math.round(this.vp.clientWidth/w)),behavior:this.motion.matches?'instant':'smooth'});
  };
  this.prev.addEventListener('click',()=>this.slide(-1),{signal});
  this.next.addEventListener('click',()=>this.slide(1),{signal});
  this.vp.addEventListener('scroll',this.update,{passive:true,signal});
  this.ro=new ResizeObserver(this.update);this.ro.observe(this.vp);this.update();
 }
 disconnectedCallback(){this.abort?.abort();this.io?.disconnect();this.ro?.disconnect();this.videos?.forEach(v=>v.pause());}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casafab-matelas-test"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    const reviewTrack = root.querySelector('.cfm-review-wall .cfm-testimonial-grid');
    if (reviewTrack && !reviewTrack.dataset.controlsBound) {
      reviewTrack.dataset.controlsBound = 'true';
      const buttons = root.querySelectorAll('[data-reviews-step]');
      const refresh = () => {
        buttons.forEach(button => {button.disabled = Number(button.dataset.reviewsStep) < 0 ? reviewTrack.scrollLeft < 2 : reviewTrack.scrollLeft + reviewTrack.clientWidth >= reviewTrack.scrollWidth - 2;});
        const card = reviewTrack.querySelector('article');
        const position = root.querySelector('.cfm-review-position');
        if (card && position) {
          const step = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(reviewTrack).gap) || 0);
          const first = Math.round(reviewTrack.scrollLeft / step) + 1;
          const visible = Math.max(1, Math.floor((reviewTrack.clientWidth + 2) / card.getBoundingClientRect().width));
          const total = reviewTrack.children.length;
          position.textContent = (visible > 1 ? first + '–' + Math.min(total, first + visible - 1) : first) + ' / ' + total;
        }
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        const card = reviewTrack.querySelector('article');
        const gap = parseFloat(getComputedStyle(reviewTrack).gap) || 0;
        reviewTrack.scrollBy({left: Number(button.dataset.reviewsStep) * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }));
      reviewTrack.addEventListener('scroll', refresh, {passive:true});
      new ResizeObserver(refresh).observe(reviewTrack);
      refresh();
    }
    const deliveryLink = root.querySelector('.cfm-delivery a');
    if (deliveryLink && !deliveryLink.dataset.bound) {
      deliveryLink.dataset.bound = 'true';
      deliveryLink.addEventListener('click', () => {
        const info = root.querySelector(deliveryLink.getAttribute('href'));
        if (info && info.tagName === 'DETAILS') info.open = true;
      });
    }
    root.querySelectorAll('.cfm-clip').forEach(clip => {
      if (clip.dataset.bound) return;
      clip.dataset.bound = 'true';
      const toggle = clip.parentElement.querySelector('.cfm-clip-toggle');
      if (toggle) {
        const syncToggle = () => { toggle.setAttribute('aria-label', clip.paused ? toggle.dataset.play : toggle.dataset.pause); toggle.firstElementChild.textContent = clip.paused ? '▶' : 'Ⅱ'; };
        toggle.addEventListener('click', () => { if (clip.paused) clip.play().catch(() => {}); else clip.pause(); });
        clip.addEventListener('play', syncToggle);
        clip.addEventListener('pause', syncToggle);
        syncToggle();
      }
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false, userPaused = false, automaticPause = false;
      const stop = () => { if (!clip.paused) { automaticPause = true; clip.pause(); } };
      const resume = () => { if (visible && !document.hidden && !motion.matches && !userPaused) clip.play().catch(() => {}); };
      clip.addEventListener('pause', () => { if (automaticPause) automaticPause = false; else userPaused = true; });
      clip.addEventListener('play', () => { userPaused = false; });
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        if (visible) resume(); else stop();
      }, { threshold: 0.25 });
      observer.observe(clip);
      motion.addEventListener('change', () => { if (motion.matches) stop(); else resume(); });
      document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); else resume(); });
    });
    const video = root.querySelector('.cfm-film');
    const button = root.querySelector('[data-film-toggle]');
    if (!video || !button || video.dataset.ready) return;
    video.dataset.ready = 'true';
    const sync = () => { button.textContent = video.paused ? button.dataset.play : button.dataset.pause; };
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    button.addEventListener('click', () => { if (video.paused) video.play().catch(sync); else video.pause(); });
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    reduceMotion.addEventListener('change', event => { if (event.matches) video.pause(); });
    if (!reduceMotion.matches) video.play().catch(sync);
    sync();
  }
  document.querySelectorAll('.cfm').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.cfm').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casafab-shared-promotion"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('cf-promotion-source')){
 customElements.define('cf-promotion-source',class extends HTMLElement{
  connectedCallback(){
   this.banner=this.querySelector('cf-campaign');
   this.promo=this.querySelector('.cf-promo-code-block');
   this.mobile=window.matchMedia('(max-width: 699px)');
   this.place=()=>{
    const header=document.querySelector('height-observer[variable="header"]');
    const bannerTarget=((this.mobile.matches&&this.dataset.pageType!=='index')||this.dataset.pageType==='collection')?this:header;
    const target=document.querySelector('[data-cf-promo-mount]');
    if(this.banner&&bannerTarget&&this.banner.parentElement!==bannerTarget)bannerTarget.prepend(this.banner);
    if(this.promo&&target&&this.promo.parentElement!==target)target.replaceChildren(this.promo);
   };
   this.mobile.addEventListener('change',this.place);
   this.observer=new MutationObserver(()=>this.place());
   this.observer.observe(document.body,{childList:true,subtree:true});
   this.place();
   this.ready=()=>this.place();
   document.addEventListener('DOMContentLoaded',this.ready,{once:true});
  }
  disconnectedCallback(){
   this.observer?.disconnect();
   this.mobile?.removeEventListener('change',this.place);
   document.removeEventListener('DOMContentLoaded',this.ready);
   this.banner?.remove();
   this.promo?.remove();
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-promo-badge"] && !Shopify.designMode) return;
  try {
    
(function(){
  const init = (scope=document) => scope.querySelectorAll('[data-cushion]').forEach(el=>{
    if(el._cushionCleanup)return;
    const tab=el.querySelector('.cf-cushion-tab'),panel=el.querySelector('.cf-cushion-panel');
    const key='casafab-cushion-intro-v1';
    let intro=false,deadline=0,remaining=3000,ready=false,interacted=false,introOffered=false;
    const seen=()=>{try{return sessionStorage.getItem(key)==='1'}catch(e){return false}};
    const remember=()=>{try{sessionStorage.setItem(key,'1')}catch(e){}};
    function open(){panel.hidden=false;tab.setAttribute('aria-expanded','true');position()}
    function close(){panel.hidden=true;tab.setAttribute('aria-expanded','false');intro=false;remember();position()}
    function engage(){interacted=true;intro=false;remember()}
    tab.addEventListener('click',()=>{engage();panel.hidden?open():close()});
    panel.addEventListener('pointerdown',engage);
    panel.addEventListener('focusin',engage);
    panel.addEventListener('pointerenter',()=>{if(intro){remaining=Math.max(0,deadline-Date.now());deadline=0}});
    panel.addEventListener('pointerleave',()=>{if(intro&&!interacted)deadline=Date.now()+remaining});
    el.querySelector('.cf-cushion-close').addEventListener('click',()=>{close();tab.focus()});
    el.addEventListener('keydown',e=>{if(e.key==='Escape'){close();tab.focus()}});
    const visible=e=>{const r=e.getBoundingClientRect(),s=getComputedStyle(e);return r.width>0&&r.height>0&&s.display!=='none'&&s.visibility!=='hidden'&&s.opacity!=='0'};
    function position(){
      if(!ready)return;
      if(el.dataset.home==='true'){
        const hero=document.querySelector('#main .shopify-section--slideshow');
        const header=document.querySelector('store-header');
        const headerBottom=header?Math.max(0,header.getBoundingClientRect().bottom):0;
        const pastHero=hero?hero.getBoundingClientRect().bottom<=headerBottom:window.scrollY>=innerHeight;
        if(!pastHero){el.hidden=true;return}
      }
      const modal=[...document.querySelectorAll('dialog[open],[role="dialog"][open],[role="dialog"][aria-modal="true"],.drawer[open]')].some(e=>!el.contains(e)&&visible(e));
      if(modal||document.fullscreenElement||document.hidden){el.hidden=true;return}
      el.hidden=false;
      const height=panel.hidden?48:Math.max(panel.offsetHeight,48),width=panel.hidden?44:242;
      const obstacles=[...document.querySelectorAll('#loox-floating-widget-btn,#carthike-chat-button-container,.header,iframe:not(#PBarNextFrame)')].filter(visible).map(e=>e.getBoundingClientRect()).filter(r=>r.right>innerWidth-width-12&&r.top<innerHeight&&r.bottom>0);
      let top=Math.round(innerHeight*.4);
      const fits=y=>y>=12&&y+height<=innerHeight-80&&!obstacles.some(r=>y<r.bottom+12&&y+height>r.top-12);
      if(!fits(top)){top=-1;for(let y=100;y+height<=innerHeight-80;y+=8){if(fits(y)){top=y;break}}}
      if(top<0){if(!panel.hidden){close();return}el.hidden=true;return}
      el.style.top=top+'px';
    }
    const delay=setTimeout(()=>{
      ready=true;position();
      
    },Number(el.dataset.delay)||1250);
    const tick=setInterval(()=>{
      if(!el.isConnected){el._cushionCleanup();return}
      position();
      if(ready&&!el.hidden&&!introOffered&&!interacted){
        introOffered=true;
        if(!seen()){intro=true;open();deadline=Date.now()+3000;remember()}
      }
      if(intro&&deadline&&!el.hidden&&Date.now()>=deadline)close();
    },250);
    el._cushionCleanup=()=>{clearTimeout(delay);clearInterval(tick)};
  });
  init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-cushion]').forEach(el=>el._cushionCleanup?.()));
})();

  } catch(e) { console.error(e); }
})();
})();
